import AuthGoogleUnavailableComponent from "./AuthGoogleUnavailableComponent";

export default AuthGoogleUnavailableComponent;